// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#uploadCustom #uploadDiv .file-uploader {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 0 8px;\n}\n#uploadCustom #uploadDiv .el-upload-list__item:first-child {\n  margin-top: 0 !important;\n}\n#uploadCustom #uploadDiv .el-upload-list__item {\n  line-height: 36px !important;\n}", ""]);
// Exports
module.exports = exports;
